module.exports = __webpack_public_path__ + "static/media/game-2-empty.dcb28a0f.png";